import { getFlags } from 'src/graphql'
import { useQueryFutures } from '.'

type Flag =
  | 'Awards Page'
  | 'New Navigation'
  | 'Usersnap'
  | 'New Card Editor'
  | 'New Dashboard'

const useFlag = (flag: Flag): boolean => {
  const [flags] = useQueryFutures(getFlags())
  return flags.value?.find(item => item.name === flag) !== undefined
}

export default useFlag
